module.exports = "<div class=\"home\">\n\n  <h1>{{$ctrl.title}}</h1>\n\n  <p>\n    If this isn't awesome I don't know what is.\n  </p>\n\n  <h2>Featured</h2>\n\n  <div class=\"featured\">\n    <giph ng-repeat=\"item in $ctrl.giphs track by $index\" giph=\"item\"></giph>\n  </div>\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/home/home.html
 ** module id = 65
 ** module chunks = 0
 **/